import { gql } from '@apollo/client';
import { DATASET_COLUMN_MAPPING_FRAGMENT } from 'graphql/secure/fragments/dataset.fragments';
import {
  DATASET_FRAGMENT,
  DATASET_TABLE_REPRESENTATION_FRAGMENT,
} from 'graphql/secure/fragments/dataset.fragments';

export const CREATE_DATASET = gql`
  mutation CreateDataset($input: CreateDatasetInput!) {
    createDataset(input: $input) {
      dataset {
        ...datasetValues
      }
    }
  }
  ${DATASET_FRAGMENT}
`;

export const UPDATE_DATASET = gql`
  mutation UpdateDataset($id: UUID!, $input: UpdateDatasetInput!) {
    updateDataset(id: $id, input: $input) {
      dataset {
        ...datasetValues
      }
    }
  }
  ${DATASET_FRAGMENT}
`;

export const DELETE_DATASET = gql`
  mutation DeleteDataset($id: UUID!) {
    deleteDataset(id: $id) {
      id
    }
  }
`;

export const PROCESS_DATASET = gql`
  mutation ProcessDataset($input: ProcessDatasetInput!) {
    processDataset(input: $input) {
      dataset {
        ...datasetValues
      }
      datasetProcessingError {
        datasetId
        datasetErrors {
          entityId
          entityType
          errorType
          errorMessage
        }
      }
    }
  }
  ${DATASET_FRAGMENT}
`;

export const PRE_PROCESS_DATASET = gql`
  mutation PreProcessDataset($input: PreProcessDatasetInput!) {
    preProcessDataset(input: $input) {
      dataset {
        ...datasetValues
        tableRepresentation {
          ...datasetTableRepresentationValues
        }
        mappedColumns {
          ...datasetColumnMappingValues
        }
      }
      datasetProcessingError {
        datasetId
        datasetErrors {
          entityId
          entityType
          errorType
          errorMessage
        }
      }
      existingPlotsFound
      existingSitesFound
    }
  }
  ${DATASET_FRAGMENT}
  ${DATASET_TABLE_REPRESENTATION_FRAGMENT}
  ${DATASET_COLUMN_MAPPING_FRAGMENT}
`;

export const CREATE_GEO_ENTITIES_EXPORT = gql`
  mutation CreateGeoEntitiesExport($input: CreateGeoEntitiesExportInput!) {
    createGeoEntitiesExport(input: $input) {
      fileUrl
    }
  }
`;
